import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ObjectCompositeFilterModel } from '@base/modules/rest/object/model/object-composite-filter.model';
import { ObjectDefinitionModel } from '@base/modules/rest/bbs-object/model/object-definition.model';
import { ModeEnum } from '@modules/master-data/model/mode.enum';
import { ObjectViewSettingsModel } from '../object-view/model/object-view-settings.model';
import { ObjectInDialogService } from './services/object-in-dialog.service';

export interface ObjectInDialogData {
  parent: any;
  objectName?: string;
  objectDefinition?: ObjectDefinitionModel;
  params?: { [key: string]: any };
  standalone: boolean;
  chooser?: boolean;
  multiSelection?: boolean;
  dataId?: number;
  data?: any;
  mode?: ModeEnum;
  compositeFilter?: ObjectCompositeFilterModel;
  fieldFilters?: { [key: string]: ObjectCompositeFilterModel };
}

@UntilDestroy()
@Component({
  selector: 'app-object-in-dialog',
  templateUrl: './object-in-dialog.component.html',
  providers: [
    ObjectInDialogService,
  ],
})
export class ObjectInDialogComponent implements OnInit, AfterViewInit {
  settings: ObjectViewSettingsModel;
  objectDefinition: ObjectDefinitionModel;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ObjectInDialogData,
              private dialogRef: MatDialogRef<any>,
              private objectInDialogService: ObjectInDialogService,
              private cdr: ChangeDetectorRef) {
    this.settings = data;
  }

  ngOnInit(): void {
    this.objectInDialogService.close$
      .pipe(untilDestroyed(this))
      .subscribe((item: any) => {
        this.dialogRef.close(item);
      });
  }

  onObjectDefinitionChanged(def: ObjectDefinitionModel): void {
    this.objectDefinition = def;
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  static open<T>(dialog: MatDialog, data: ObjectInDialogData): MatDialogRef<any, T> {
    return dialog.open(ObjectInDialogComponent, {
      data: data,
      panelClass: 'u-mat-dialog-without-space-x',
      width: '90vw',
      height: '90vh',
    });
  }
}
